import axios from "../../utils/axios";

const getVideos = async (tags, searchText, author) => {
    let queryString = "";

    if (tags.length > 0) {
        queryString += tags.map((tag) => `tags_like=${tag}`).join("&");
    }

    if (searchText.length > 0) {
        queryString += `q=${searchText}`;
    }

    if (author.length > 0) {
        queryString += `author=${author}`;
    }

    const response = await axios.get(`/videos?${queryString}`);

    return response.data;
};

export default getVideos;
